<template>
  <Modal v-bind="{ redirectOnClose: true }">
    <div class="modal color-red max-w-md mx-auto" slot-scope="{ closeModal }" @click.stop>
      <div class="modal__header">
        <h6 class="heading">
          {{ $t('deleteProduct') | capitalize }}
        </h6>
      </div>
      <div class="modal__body space-y-8">
        <p class="text-center">
          {{ $t('deleteConfirmation') | capitalize }}
        </p>
        <div class="space-x-2 text-right">
          <button
            type="button"
            :disabled="deleting"
            class="btn style-link px-6"
            @click="closeModal"
          >
            {{ $t('cancel') | capitalize }}
          </button>
          <button :disabled="deleting" class="btn btn-danger px-6" @click="deleteProduct">
            {{ $t('delete') | capitalize }}
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/Ui/Modal.vue';

export default {
  name: 'EditProductModal',
  components: {
    Modal,
  },
  props: {
    deleting: Boolean,
    productId: {
      type: String,
      required: true,
    },
  },
  methods: {
    deleteProduct() {
      this.$emit('submit', this.productId);
    },
    backToProduct() {
      this.$router.go(-1);
    },
  },
};
</script>
